import axiosInstance from "../../../api/axiosInstance";

export default {
  namespaced: true,
  state: {
    classRooms: [],
    classRoom: {},
  },
  actions: {
    async loadClassRooms({ commit }) {
      const response = await axiosInstance.get("/class_rooms");
      commit("setClassRooms", response.data);
    },
    async loadClassRoom({ commit }, id) {
      const response = await axiosInstance.get(`/class_rooms/${id}`);
      commit("setClassRoom", response.data);
    },
    createClassRoom({ commit, state }, data) {
      return axiosInstance
        .post("/class_rooms", data)
        .then((response) => {
          commit("setClassRooms", [...state.classRooms, response.data]);
          return response;
        })
        .catch((error) => {
          return error.response;
        });
    },
    updateClassRoom({ commit, state }, data) {
      return axiosInstance
        .put(`/class_rooms/${data.id}`, data)
        .then((response) => {
          commit(
            "setClassRooms",
            state.classRooms.map((classRoom) =>
              classRoom.id === data.id ? response.data : classRoom
            )
          );
          return response;
        })
        .catch((error) => {
          return error.response;
        });
    },
    sendInvite({ commit, state }, data) {
      return axiosInstance
        .post(`/class_rooms/${data.id}/invite`, data)
        .then((response) => {
          return response;
        });
    },
    deleteClassRoom({ commit, state }, id) {
      return axiosInstance.delete(`/class_rooms/${id}`).then((response) => {
        return response;
      });
    },
    assignEpisode({}, { id, episodeId, assigned }) {
      return axiosInstance
        .post(`/class_rooms/${id}/assign_episode`, {
          episode_id: episodeId,
          assigned,
        })
        .then((response) => {
          return response;
        });
    },
    updateUserClassRoom({ commit, state }, { id, role }) {
      return axiosInstance
        .put(`/user_class_rooms/${id}`, { user_class_room: { role } })
        .then((response) => {
          return response;
        });
    },
    removeUserClassRoom({ commit, state }, id) {
      return axiosInstance.delete(`/user_class_rooms/${id}`).then((response) => {
        return response;
      });
    },
    fetchGoogleClassrooms() {
      return axiosInstance
        .get('/class_rooms/google_classrooms')
        .then((response) => response)
        .catch((error) => error.response);
    },
    async syncGoogleClassrooms(_context, selection = null) {
      const response = await axiosInstance.post('/class_rooms/sync_google_classroom', { selection });
      return response;
    },
    disconnectGoogleClassroom(_context, id) {
      return axiosInstance.post(`/class_rooms/${id}/disconnect_google_classroom`, {
        confirm_delete_students: true,
      });
    },
    async pushToGoogleClassroom(_context, { id, includeAnnouncement, consentRetry = false }) {
      return axiosInstance.post(`/class_rooms/${id}/push_to_classroom`, {
        include_announcement: includeAnnouncement,
        consent_retry: consentRetry,
      });
    },
  },
  mutations: {
    setClassRooms(state, classRooms) {
      state.classRooms = classRooms;
    },
    setClassRoom(state, classRoom) {
      state.classRoom = classRoom;
    },
  },
  getters: {
    classRooms: (state) => state.classRooms,
    classRoom: (state) => state.classRoom,
  },
};
